module.exports = __webpack_public_path__ + "assets/imgs/gmp/dv.e013a01be2f4c527b5b4f7125fc2886b.svg";